<template>
  <div>
    <v-data-table
        :headers="tabla.headers"
        :items="tabla.items"
        :options.sync="tabla.options"
        :server-items-length="tabla.count"
        :fixed-header="true"
        class="elevation-3"
        calculate-widths
        :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50], itemsPerPageText: $t('Registros por página') }"
        :no-data-text="$t('No hay datos')"
        :no-results-text="$t('No hay datos')"
    >
      <!-- Columna fecha -->
      <template v-slot:item.created="{ item }">
        <span>{{ item.created | moment('DD/MM/YYYY HH:mm') }}</span>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn x-small fab icon @click="$emit('on_click_edit', item)">
          <v-icon color="primary">mdi-eye</v-icon>
        </v-btn>

        <v-btn x-small fab icon @click="print_cuestionario(item)">
          <v-icon color="primary">mdi-printer</v-icon>
        </v-btn>

        <v-btn x-small fab icon @click="$emit('on_click_delete', item)">
          <v-icon color="red">mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>


<script>
import useTable from "@/composables/useTable"

export default {
  name: 'TablaCuestionariosRealizados',
  props: {
    // Filtros para realizar la búsqueda
    selected_filters: {
      type: Object,
      default: {},
      required: true
    },
  },
  setup(props, {root}){

    const { tabla, get_items } = useTable("cliente/get_cuestionarios_realizados")

    const get_cuestionarios_realizados = async () => get_items(props['selected_filters'])
    get_cuestionarios_realizados()

    tabla.value.headers = [
      { text: root.$t('Cuestionario'), value: 'cuestionario.descripcion', class: "primary white--text"},
      { text: root.$t('Empleado'), value: 'created_by.text', class: "primary white--text"},
      { text: root.$t('Fecha'), value: 'created', class: "primary white--text"},
      { text: '', value: 'actions', class: "primary white--text", sortable: false, align: 'right', width: "128px"},
    ]

    const print_cuestionario = async (cuestionario) => {
      try{
        await root.$store.dispatch("cliente/print_cuestionario_realizado", cuestionario)
      }catch (err){
        root.$snotify.error(
          root.$t("Ha ocurrido un error"),
          root.$t('Atención {0}', [root.$store.getters['auth/user'].first_name])
        )
      }
    }

    return {
      tabla,
      get_cuestionarios_realizados,
      print_cuestionario
    }
  }
}
</script>
